<div class="modal-body">
  <div class="modal-text-wrapper-info">
    <p class="title">{{title}}</p>
    <p class="body">{{information}}</p>
    <label style="font-size: 12px; font-family: 'HelveticaNeue'; color: #58595B;">Input values from 0-100. Two decimal place is allowed.</label><br>
    <input type="text" maxlength="5" id="cbm_rating" (keyup)="checkValid($event)" (onchange)="checkValid($event)" style="padding-right: 30px; color: #333333; font-size: 16px; font-family: 'HelveticaNeue'; text-align: right; width: 195px; height: 45px; border-radius: 10px; border-color: #7376BC;"><span style="padding-top: inherit; margin-left: -30px;">%</span>
    <br>

      @if (isNotNum) {
        <span style="font-size: 13px; font-family: 'HelveticaNeue'; color: red;">
          Enter a numerical value from 0 to 100
        </span>
      }

    </div>
    <br>
      <br>
        <button type="button" id="btn_save" class="modal-btn-primary" disabled="isNotNum" (click)="submitRating()">{{positiveButton}}</button>
        <button type="button" class="modal-btn-secondary" (click)="activeModal.dismiss('')">{{negativeButton}}</button>
      </div>